<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		<!-- banner -->
		<qBanner></qBanner>
		
		
	
		
		<div class="read">
			<div class="read-hd">
				<q-title title="报告打印" time="86"></q-title>
				<q-step :step="3"></q-step>
			</div>
			
			<div class="user-info-row fcc">
				<div>
					<span>姓名：</span>
					<b>张三</b>
				</div>
				<div>
					<span>性别：</span>
					<b>男</b>
				</div>
				<div>
					<span>门诊号码：</span>
					<b>9527</b>
				</div>
			</div>
			
			
			<div class="print-list-tiems">
				<div class="print-item" v-for="(item,index) in list" :class="{on : item.check}">
					<div class="col1" @click="item.check=!item.check">
						<img src="../../assets/icon/icon-check2.png"  v-if="item.check">
						<img src="../../assets/icon/icon-check.png"  v-else>
					</div>
					<div class="col2">
						<div class="name">{{item.name}}</div>
					</div>
					<div class="col3">
						<div class="time">
							{{item.time}}
						</div>
					</div>
					<div class="col4">
						<div class="fcc">
							<button type="button" class="btn-look" @click="printLook">
								<img src="../../assets/icon/icon-search.png" >
								<span>查看</span>
							</button>
							<button type="button" class="btn-print" @click="toPrint" v-if="item.check">
								<img src="../../assets/icon/printer2.png" >
								<span>打印</span>
							</button>
							<button type="button" class="btn-print" @click="toPrintTips" v-else>
								<img src="../../assets/icon/printer2.png" >
								<span>打印</span>
							</button>
						</div>
					</div>
				</div>				
			</div>
			
			
			<div class="list-page fcc">
				<a>上一页</a>
				<span>第</span>
				<span>1/15</span>
				<span>页</span>
				<a>下一页</a>
			</div>
			
			
			<div class="foot-buttons fc-bet">
				<a href="/" class="btn-home fcc">
					<img src="../../assets/icon/icon-home.png" >
					<span>首页</span>
				</a>
				<a class="btn-blue fcc" @click="toPrint">
					<img src="../../assets/icon/printer.png" >
					<span>全部打印</span>
				</a>
				<a class="btn-return fcc" @click="returnStep()">
					<img src="../../assets/icon/icon-return.png" >
					<span>返回</span>
				</a>
			</div>
		
		</div>
		<!-- 打印预览 -->
		<qPrint v-if="printPreviewShow" @close="close"></qPrint>
		<!-- 打印中 -->
		<qPrintIng v-if="printIngShow"></qPrintIng>
		<!-- 打印ok -->
		<qPopPrintOk v-if="printOk" @close-read="closeReadList"></qPopPrintOk>
	</div>
</template>

<script>
	import qHead from '@/components/q-head/q-head.vue';
	import qBanner from '@/components/q-head/q-banner.vue';
	import qTitle from '@/components/q-read/q-title.vue';
	import qStep from '@/components/q-read/q-step.vue';
	
	import qPrint from '@/components/q-read/q-print.vue';
	import qPrintIng from '@/components/q-pop/q-pop-print-ing.vue';
	import qPopPrintOk from '@/components/q-pop/q-pop-print.vue';
	
	
	export default {
		components: {
			qHead,qBanner,qStep,qTitle,qPrint,qPrintIng,qPopPrintOk
		},
		data() {
			return {
				printPreviewShow:false,
				printIngShow:false,
				printOk:false,
				list:[
					{
						check:false,
						name:"血常规报告",
						time:"2021-12-03 19:33:08"
					},
					{
						check:false,
						name:"血常规报告2",
						time:"2021-12-03 19:33:08"
					},
					{
						check:false,
						name:"血常规报告3",
						time:"2021-12-03 19:33:08"
					},
					{
						check:false,
						name:"血常规报告4",
						time:"2021-12-03 19:33:08"
					},
					{
						check:false,
						name:"血常规报告5",
						time:"2021-12-03 19:33:08"
					},
					{
						check:false,
						name:"血常规报告6",
						time:"2021-12-03 19:33:08"
					},
					{
						check:false,
						name:"血常规报告7",
						time:"2021-12-03 19:33:08"
					}
				],
				checkAll:-1
			}
		},
		mounted() {
			
		},
		methods:{
			// 打印预览 点击查看按钮
			printLook(){
				this.printPreviewShow=true
			},
			//打印预览弹出框里面的确定按钮
			close(data){
				this.printPreviewShow=data
			},
			//点击打印按钮
			toPrint(){
				var that=this;
				that.printIngShow=true
				that.printOk=false
				//模拟3秒打印完成 关闭正在打印中
				setTimeout(()=>{
					that.printIngShow=false
					// 显示打印完成
					that.printOk = true
				},3000)
			},
			toPrintTips(){
				 this.$alert('未勾选的不能打印，请先勾选！', '温馨提示', {
				          confirmButtonText: '确定',
				          callback: action => {
				             
				          }
				        });
			},
			closeReadList() {
			  this.printOk = false
			},
		},
		beforeDestroy() {
			//clearInterval(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
	
</style>
